import { render } from "./StatisticalEvalTeamPage.vue?vue&type=template&id=420d6e63&scoped=true&ts=true"
import script from "./StatisticalEvalTeamPage.vue?vue&type=script&lang=ts"
export * from "./StatisticalEvalTeamPage.vue?vue&type=script&lang=ts"

import "./StatisticalEvalTeamPage.vue?vue&type=style&index=0&id=420d6e63&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/DanhGia_FE_HV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-420d6e63"]])

export default __exports__